<template>
  <!-- <input :value="value" @input="updateValue" @focus="selectAll" @blur="formatValue" class="el-input__inner"> -->
  <el-input
    v-model="currentValue"
    @input="handleInput"
    @focus="selectAll"
    @blur="formatValue"
    @change="handleInputChange"
    :disabled="disabled"
  >
    <template v-if="prepend" slot="prepend">{{prepend}}</template>
    <template v-if="append" slot="append">{{append}}</template>
  </el-input>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    append: {
      type: String
    },
    prepend: {
      type: String
    },
    decimal1: {},
    min: {
      type: Number,
      default: -Infinity
    },
    max: {
      type: Number,
      default: Infinity
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentValue: this.value,
      userInput: null
    }
  },
  mounted () {
    this.$nextTick(this.formatValue)
  },
  methods: {
    // handleInput (value) {
    //   clearTimeout(this.timer)
    //   this.timer = setTimeout(() => {
    //     this.updateValue(value)
    //   }, 1000)
    // },
    handleInput(value) {
      this.userInput = value
    },
    handleInputChange(value) {
      const newVal = value === '' ? undefined : Number(value)
      if (!isNaN(newVal) || value === '') {
        this.setCurrentValue(newVal)
      }
      this.userInput = null
    },
    setCurrentValue(newVal) {
      const oldVal = this.currentValue
      if (newVal >= this.max) newVal = this.max
      if (newVal <= this.min) newVal = this.min
      if (oldVal === newVal) return
      this.userInput = null
      this.$emit('input', newVal)
      this.$emit('change', newVal, oldVal)
      this.currentValue = newVal
    },
    updateValue (valueStr) {
      let result = this.parse(valueStr, this.value)
      let v = result.value
      if (v < this.min) v = this.min
      if (v > this.max) v = this.max
      // console.assert(!result.warning, result.warning)
      this.$emit('input', v)
      setTimeout(this.formatValue, 20)
      // console.log('undated', v)
    },
    formatValue () {
      this.$el.querySelector('input').value = this.format(this.currentValue)
    },
    // focus
    selectAll (event) {
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function () {
        event.target.select()
      }, 0)
    },
    format (number) {
      if (this.decimal1 === undefined || this.decimal1 === null) return number
      return (Math.trunc(number * 1000000000000) / 1000000000000).toFixed(this.decimal1)
    },
    parse (newString, oldNumber) {
      let CleanParse = function (value) {
        return {value}
      }
      let CurrencyWarning = function (warning, value) {
        return {
          warning,
          value,
          attempt: newString
        }
      }
      let NotAValidDollarAmountWarning = function (value) {
        return new CurrencyWarning(newString + '不合法的数字', value)
      }
      // let AutomaticConversionWarning = function (value) {
      //   return new CurrencyWarning(newString + '已自动转换为' + value, value)
      // }

      let newNumber = Number(newString)
      let indexOfDot = newString.indexOf('.')
      let indexOfE = newString.indexOf('e')

      if (isNaN(newNumber)) {
        if (
          indexOfDot === -1 &&
          indexOfE > 0 &&
          indexOfE === newString.length - 1 &&
          Number(newString.slice(0, indexOfE)) !== 0
        ) {
          return new CleanParse(oldNumber)
        } else {
          return new NotAValidDollarAmountWarning(oldNumber)
        }
      }

      // let newCurrencyString = this.format(newNumber)
      // let newCurrencyNumber = Number(newCurrencyString)

      return new CleanParse(newNumber)

      // if (newCurrencyNumber === newNumber) {
      //   if (indexOfE !== -1 && indexOfE === newString.length - 2) {
      //     return new AutomaticConversionWarning(newNumber)
      //   } else {
      //     return new CleanParse(newNumber)
      //   }
      // } else {
      //   return new NotAValidDollarAmountWarning(
      //     newNumber > newCurrencyNumber
      //       ? newCurrencyNumber
      //       : oldNumber
      //   )
      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dynamic-form/input-number.vue